import { ref, computed, useCssModule } from "vue";
import { g as getUid } from "./assets/index-Df_FM1j-.js";
import "./assets/index-CgZzOVq6.js";
import "vue-demi";
import { u as useDataTestIdProp } from "./assets/index-BNd8MWnO.js";
import { u as useDisabledProp } from "./assets/index-DKxr0Yto.js";
import { u as useFullWidthProp } from "./assets/index-4vIud5LZ.js";
import { u as useInputProps } from "./assets/SingleMessage-Dv2wNb7f.js";
import { u as useValidationsProp } from "./assets/index-vzP2cezV.js";
import "vue-router";
import "dompurify";
import { onClickOutside } from "@vueuse/core";
import XLink from "./XLink.js";
import XTooltip from "./XTooltip.js";
import MessagesContainer from "./MessagesContainer.js";
import { n as normalizeComponent } from "./assets/_plugin-vue2_normalizer-VvYS6rEj.js";
import "vue-i18n";
import "./locales.js";
import "./assets/XIcon-U9bwokTN.js";
import "@fortawesome/vue-fontawesome";
import "./assets/BaseLink-KuovKwoP.js";
import "./assets/index-Ca8wHgNc.js";
import "./assets/XDropdown-Bc_0Fycm.js";
import "@floating-ui/dom";
import "./BasicContent.js";
import "./ContentBox.js";
import "./CloseButton.js";
import "./AdvancedContent.js";
function useFocus(options) {
  const { props, contentRef } = options;
  const isFieldFocused = ref(false);
  const canFocus = computed(() => props.focusable && props.grouped && !props.disabled);
  function setFocus() {
    if (canFocus.value) isFieldFocused.value = true;
  }
  function unsetFocus() {
    if (canFocus.value) isFieldFocused.value = false;
  }
  onClickOutside(contentRef, unsetFocus);
  return {
    setFocus,
    isFieldFocused
  };
}
const { getFullWidthClass } = useFullWidthProp();
function useClasses(options) {
  const { props, isFieldFocused } = options;
  const $style = useCssModule();
  const focusClass = computed(() => ({
    [$style.hasFocus]: isFieldFocused.value
  }));
  const flexibleClass = computed(() => ({
    [$style.isFlexible]: props.flexible
  }));
  const groupClass = computed(() => ({
    [$style.isGrouped]: props.grouped
  }));
  const messageTypeClass = computed(() => ({
    [$style[props.messageType]]: props.message
  }));
  const { fullWidthClass } = getFullWidthClass(props);
  const fieldClasses = computed(() => ({
    ...fullWidthClass.value,
    ...messageTypeClass.value
  }));
  const contentClasses = computed(() => ({
    ...focusClass.value,
    ...groupClass.value,
    ...messageTypeClass.value,
    ...flexibleClass.value
  }));
  return {
    fieldClasses,
    contentClasses
  };
}
const XFormField$1 = "_XFormField_vih9i_1";
const header = "_header_vih9i_9";
const label = "_label_vih9i_17";
const requiredIndicator = "_requiredIndicator_vih9i_25";
const helpLink = "_helpLink_vih9i_31";
const helpTooltip = "_helpTooltip_vih9i_32";
const content = "_content_vih9i_36";
const isFlexible = "_isFlexible_vih9i_48";
const isGrouped = "_isGrouped_vih9i_51";
const hasFocus = "_hasFocus_vih9i_93";
const error = "_error_vih9i_99";
const isFullWidth = "_isFullWidth_vih9i_102";
const style0 = {
  XFormField: XFormField$1,
  header,
  label,
  requiredIndicator,
  helpLink,
  helpTooltip,
  content,
  isFlexible,
  isGrouped,
  hasFocus,
  error,
  isFullWidth
};
const { createFullWidthProp } = useFullWidthProp();
const { createDisabledProp } = useDisabledProp();
const { createTestIdProp, setupTestId } = useDataTestIdProp();
const { createValidationsProp } = useValidationsProp();
const {
  createMessageProps,
  createAdditionalMessagesProp,
  createLabelProps,
  createFormFieldProps,
  createRequiredProp
} = useInputProps();
const __default__ = {
  name: "XFormField",
  components: {
    XTooltip,
    XLink,
    MessagesContainer
  }
};
const _sfc_main = /* @__PURE__ */ Object.assign(__default__, {
  props: {
    ...createRequiredProp(),
    ...createLabelProps(),
    ...createFormFieldProps(),
    ...createValidationsProp(),
    ...createAdditionalMessagesProp(),
    ...createMessageProps(),
    ...createDisabledProp(),
    ...createFullWidthProp(),
    ...createTestIdProp()
  },
  emits: ["error"],
  setup(__props, { emit }) {
    const props = __props;
    const { formatTestId } = setupTestId(props);
    const contentRef = ref(null);
    const uuid = getUid("field-");
    const labelId = getUid("label-");
    const { setFocus, isFieldFocused } = useFocus({
      props,
      contentRef
    });
    const { fieldClasses, contentClasses } = useClasses({
      props,
      isFieldFocused
    });
    function canShowHeader() {
      return props.label || props.helpLink || props.helpTooltip;
    }
    return { __sfc: true, createFullWidthProp, createDisabledProp, createTestIdProp, setupTestId, createValidationsProp, createMessageProps, createAdditionalMessagesProp, createLabelProps, createFormFieldProps, createRequiredProp, props, emit, formatTestId, contentRef, uuid, labelId, setFocus, isFieldFocused, fieldClasses, contentClasses, canShowHeader, XLink, XTooltip, MessagesContainer };
  }
});
var _sfc_render = function render() {
  var _vm = this, _c = _vm._self._c, _setup = _vm._self._setupProxy;
  return _c("div", { class: [_vm.$style.XFormField, _setup.fieldClasses], attrs: { "data-testid": _setup.formatTestId() } }, [_setup.canShowHeader() ? _c("div", { class: _vm.$style.header, attrs: { "data-testid": _setup.formatTestId("header") } }, [_vm.label ? _c("label", { class: _vm.$style.label, attrs: { "id": _setup.labelId, "for": _setup.uuid, "data-testid": _setup.formatTestId("label") } }, [_vm._v(" " + _vm._s(_vm.label) + " ")]) : _vm._e(), _vm.required ? _c("span", { class: _vm.$style.requiredIndicator, attrs: { "data-testid": _setup.formatTestId("required") } }, [_vm._v(" * ")]) : _vm._e(), _vm.helpLink ? _c(_setup.XLink, { class: _vm.$style.helpLink, attrs: { "to": _vm.helpLink, "icon": "question-circle", "target": "_blank", "no-padding": "", "data-testid": _setup.formatTestId("helpLink") } }) : _vm._e(), _vm.helpTooltip ? _c(_setup.XTooltip, { class: _vm.$style.helpTooltip, attrs: { "data-testid": _setup.formatTestId("tooltip") } }, [_vm._v(" " + _vm._s(_vm.helpTooltip) + " ")]) : _vm._e()], 1) : _vm._e(), _c("fieldset", { ref: "contentRef", class: [_vm.$style.content, _setup.contentClasses], attrs: { "tabindex": "-1", "disabled": _vm.disabled, "data-testid": _setup.formatTestId("content") }, on: { "click": function($event) {
    return _setup.setFocus();
  } } }, [_vm._t("default", null, { "uuid": _setup.uuid, "labelId": _setup.labelId })], 2), _c(_setup.MessagesContainer, { attrs: { "message": _vm.message, "message-type": _vm.messageType, "additional-messages": _vm.additionalMessages, "validations": _vm.validations, "data-testid": _vm.dataTestid }, on: { "error": function($event) {
    return _setup.emit("error", $event);
  } } })], 1);
};
var _sfc_staticRenderFns = [];
const __cssModules = {
  "$style": style0
};
function _sfc_injectStyles(ctx) {
  for (var key in __cssModules) {
    this[key] = __cssModules[key];
  }
}
var __component__ = /* @__PURE__ */ normalizeComponent(
  _sfc_main,
  _sfc_render,
  _sfc_staticRenderFns,
  false,
  _sfc_injectStyles
);
const XFormField = __component__.exports;
export {
  XFormField as default
};
